<template>
  <el-row :gutter="20">
    <el-col :span="8">
      <el-input v-model="callingCode" maxlength="5" clearable oninput="value=value.replace(/[^\d]/g,'')"></el-input>
    </el-col>
    <el-col :span="16">
      <el-input v-model="mobileNumber" maxlength="13" clearable oninput="value=value.replace(/[^\d]/g,'')"></el-input>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: "LandlineNumber",
    model: {
      prop: 'mobile',
      event: 'change'
    },
    props: ['mobile'],
    data() {

      return {
        options: [{
          value: '+63',
          label: '+63'
        },],
        callingCode: '',
        mobileNumber: '',
      };
    },

    watch: {
      mobile(newValue) {
        this.callingCode = newValue.split("-")[0] ?  newValue.split("-")[0] : ""
        this.mobileNumber = newValue.split("-")[1]?  newValue.split("-")[1] : ""
      },
      callingCode() {
        let result = this.calculateNumber()

        this.$emit('change', result);
      },
      mobileNumber() {
        let result = this.calculateNumber()

        this.$emit('change', result);
      }
    },

    methods: {
      calculateNumber() {
        let result = ""
        if(this.callingCode === "" && this.mobileNumber === "") {
          result = ""
        }else {
          result = `${this.callingCode}-${this.mobileNumber}`
        }
        return result
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>